module.exports = __webpack_public_path__ + "19145d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/ClinicaMedica/749.jpg
// module id = 1320
// module chunks = 0 1